export enum BackofficeMenu {
  Dashboard = 'Dashboard',
  Users = 'Users',
  Messages = 'Messages',
  AiHub = 'AI Hub',
  BusinessHours = 'Business Hours',
  Reports = 'Reports',
  Scheduler = 'Scheduler',
  QueueMonitor = 'Queue Monitor'
}

